<main id="main-content" class="ds-product-page about-page">
  <section class="hero" aria-labelledby="hero-title">
    <p class="eyebrow">{{ t('about.eyebrow') }}</p>
    <h1 id="hero-title">{{ t('about.title') }}</h1>
    <p class="lede">{{ t('about.lede') }}</p>
    <div class="test-entry">
      <a dsButton size="large" routerLink="/">{{ t('about.startTest') }}</a>
      <span>{{ t('about.testNote') }}</span>
    </div>
  </section>
  <section dsCard id="for-organizations" class="safeguard" aria-labelledby="safeguard-title">
    <p class="eyebrow">{{ t('about.safeguard') }}</p>
    <h2 id="safeguard-title">{{ t('about.decision') }}</h2>
    <p>{{ t('about.decisionText') }}</p>
  </section>
</main>
